module.exports = __webpack_public_path__ + "img/img-related08.6dd6ebfb.jpg";